<template>
  <div class="partner-with-us">
    <section
      class="section-b-space blog-new help-details"
      :style="
        `background-image:url(${page_info.page.header_background}); background-size: cover; background-position: center center; background-repeat: no-repeat; display: block;`
      "
    ></section>
    <section class="section-b-space news-article pt-0 new-with">
      <div class="container">
        <div class="row join-us">
          <div class="col-sm-12">
            <div class="latest-news ratio_40">
              <div
                class="blog-tab bg-size"
                :style="
                  `background-image:url(${page_info.page.header_image}); background-size: cover; background-position: center center; background-repeat: no-repeat; display: block;`
                "
              >
                <div class="content-blog">
                  <h2>{{ _T(page_info.page.header_heading) }}</h2>
                  <h6>{{ _T(page_info.page.header_desc) }}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-b-space pt-0">
      <div class="container partner-row">
        <div class="row">
          <div class="col-sm-12">
            <div class="with-us">
              <h3>{{ _T(page_info.page.page_heading) }}</h3>
              <h6>{{ _T(page_info.page.page_desc) }}</h6>
              <div class="with-us-card">
                <div class="header-us">
                  <h4>
                    {{ _T('Bussiness Information') }}
                    <span>01</span>
                  </h4>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <form class="default-form1" v-if="false">
                      <div class="form-group">
                        <label for="area-select">
                          {{ _T('Bussiness Type') }}
                          <span>*</span>
                        </label>
                        <v-select
                          id="area-select"
                          :options="page_info.business_type"
                          v-model="form_data.business_type"
                          :placeholder="_T('Please select business type')"
                        />
                        <div
                          class="invalid-feedback"
                          style="display:contents"
                          v-if="error.business_type"
                        >
                          {{ error.business_type[0] }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label>
                          {{ _T('Bussiness Name') }}
                          <span>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Goorder Restaurant"
                          v-model="form_data.brand_name"
                        />
                        <div
                          class="invalid-feedback"
                          style="display:contents"
                          v-if="error.brand_name"
                        >
                          {{ error.brand_name[0] }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="country">
                          {{ _T('Country') }}
                          <span>*</span>
                        </label>
                        <v-select
                          id="country"
                          :options="page_info.country"
                          v-model="form_data.country"
                          :placeholder="_T('Country')"
                        />
                        <div
                          class="invalid-feedback"
                          style="display:contents"
                          v-if="error.country"
                        >
                          {{ error.country[0] }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label>
                          {{ _T('No of Bussiness Locations') }}
                          <span>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="10-20"
                          v-model="form_data.locations"
                        />
                        <div
                          class="invalid-feedback"
                          style="display:contents"
                          v-if="error.locations"
                        >
                          {{ error.locations[0] }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label>{{ _T('Cuisine Types Served') }}</label>
                        <textarea
                          class="form-control"
                          rows="3"
                          v-model="form_data.cuisine_type"
                        ></textarea>
                      </div>
                      <div class="form-group social-account">
                        <label @click="addSocicalAccount">
                          {{ _T('Social Media Account') }}
                          <div class="add-plus">
                            <img src="/images/svg/global/plus.svg" alt />
                          </div>
                        </label>

                        <div
                          class="row"
                          :key="key"
                          v-for="(item, key) in form_data.social_media"
                        >
                          <div class="col-sm-4 pr-0 mb-4">
                            <v-select
                              id="social-account-select"
                              :options="page_info.social_media"
                              v-model="item.for"
                              :placeholder="_T('Social account')"
                            />
                          </div>
                          <div class="col-sm-8">
                            <input
                              id="user-account-url"
                              type="text"
                              class="form-control"
                              value="Username Account"
                              v-model="item.value"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="form-group mb-0">
                        <label>{{ _T('More Details') }}</label>
                        <textarea
                          class="form-control"
                          rows="3"
                          v-model="form_data.more_details"
                        ></textarea>
                        <div
                          class="invalid-feedback"
                          style="display:contents"
                          v-if="error.more_details"
                        >
                          {{ error.more_details[0] }}
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="col-lg-6">
                    <div class="upload-images">
                      <div class="media">
                        <div class="round-bulb">
                          <img src="/images/svg/bulb-y.svg" alt />
                        </div>
                        <div class="media-body">
                          <p>
                            {{
                              _T(
                                'Please upload JPEG or PNG file types only,the file size must not exceed 1 MB'
                              )
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="upload-box">
                        <div>
                          <label for="brand_logo">
                            <div class="plus-icon" v-if="!form_data.brand_logo">
                              <img
                                src="/images/svg/global/plus.svg"
                                alt="Upload Image"
                              />
                            </div>
                            <div v-else>
                              <img
                                :src="form_data.brand_logo"
                                style="max-height: 150px;max-width: 326px;"
                              />
                            </div>
                          </label>
                          <h6>
                            {{ _T('Upload Bussiness Logo') }}
                            <span class="d-block">{{ _T('(Optional)') }}</span>
                          </h6>
                          <input
                            type="file"
                            @change="handleUpload($event, 'brand_logo')"
                            id="brand_logo"
                            style="display:none"
                            accept="image/*"
                          />
                        </div>
                      </div>
                      <div
                        class="invalid-feedback"
                        style="display: contents;"
                        v-if="error.brand_logo"
                      >
                        {{ error.brand_logo[0] }}
                      </div>

                      <div class="upload-box">
                        <div>
                          <label for="brand_image">
                            <div
                              class="plus-icon"
                              v-if="!form_data.brand_image"
                            >
                              <img
                                src="/images/svg/global/plus.svg"
                                alt="Upload Image"
                              />
                            </div>
                            <div v-else>
                              <img
                                :src="form_data.brand_image"
                                style="max-height: 150px;max-width: 326px;"
                              />
                            </div>
                          </label>
                          <h6>
                            {{ _T('Upload Bussiness Image') }}
                            <span class="d-block">{{ _T('(Optional)') }}</span>
                          </h6>
                          <input
                            type="file"
                            @change="handleUpload($event, 'brand_image')"
                            id="brand_image"
                            style="display:none"
                            accept="image/*"
                          />
                        </div>
                      </div>
                      <div
                        class="invalid-feedback"
                        style="display: contents;"
                        v-if="error.brand_image"
                      >
                        {{ error.brand_image[0] }}
                      </div>

                      <div class="upload-box upload-menu">
                        <div>
                          <label for="menu_items">
                            <div class="plus-icon" v-if="!form_data.menu_items">
                              <img
                                src="/images/svg/global/plus.svg"
                                alt="Upload Image"
                              />
                            </div>
                            <div v-else>
                              {{ page_info.menu_item_file }}
                            </div>
                          </label>
                          <h6>
                            {{ _T('Upload Menu Items') }}
                            <span class="d-block"></span>
                            <a href="/files/menu_item_sample.xls" class="badge">
                              Download Sample
                              <span
                                ><img
                                  src="/images/svg/global/arrow_d.svg"
                                  alt="Upload XLS"
                              /></span>
                            </a>
                          </h6>
                          <input
                            type="file"
                            @change="handleUpload($event, 'menu_items')"
                            id="menu_items"
                            style="display:none"
                            accept=".xls"
                          />
                        </div>
                      </div>
                      <div
                        class="invalid-feedback"
                        style="display: contents;"
                        v-if="error.menu_items"
                      >
                        {{ error.menu_items[0] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6" v-if="hideOrderType">
            <div class="with-us">
              <div class="with-us-card">
                <div class="header-us">
                  <h4>
                    {{ _T('Order Type') }}
                    <span>{{ _T('02') }}</span>
                  </h4>
                </div>
                <div class="order-choice">
                  <div class="choice-option order-choice-option">
                    <h6>
                      {{ _T('What are the types of orders?') }}
                      <span>{{ _T('MULTIPLE CHOICE') }}</span>
                    </h6>
                    <div class="desired-time">
                      <div class="box-checkbox">
                        <ul class="timing-checkbox multichoice">
                          <li
                            :key="key"
                            v-for="(item, key) in page_info.order_types"
                          >
                            <label :for="'chk-ani1' + item.name">
                              <input
                                class="checkbox_animated"
                                :id="'chk-ani1' + item.name"
                                type="checkbox"
                                checked
                                :value="item.value"
                                v-model="form_data.order_types"
                              />
                              <span>{{ item.name }}</span>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="choice-option">
                    <h6>{{ _T('Are you on other delivery platforms?') }}</h6>
                    <div class="desired-time">
                      <div class="box-checkbox">
                        <ul class="timing-checkbox">
                          <li>
                            <label for="chk-ani4">
                              <input
                                class="radio_animated"
                                id="chk-ani4"
                                type="radio"
                                name="rdo-ani"
                                checked
                                :value="false"
                                v-model="form_data.other_delivery_platrforms"
                              />
                              <span>{{ _T('No') }}</span>
                            </label>
                          </li>
                          <li>
                            <label for="chk-ani5">
                              <input
                                class="radio_animated"
                                id="chk-ani5"
                                type="radio"
                                name="rdo-ani"
                                :value="true"
                                v-model="form_data.other_delivery_platrforms"
                              />
                              <span>{{ _T('Yes') }}</span>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :class="hideOrderType ? 'col-lg-6' : 'col-lg-12'">
            <div class="with-us">
              <div class="with-us-card">
                <div class="header-us">
                  <h4>
                    {{ _T('Contact Information') }}
                    <span>{{ hideOrderType ? '03' : '02' }}</span>
                  </h4>
                </div>
                <form class="default-form1" v-if="false">
                  <div class="form-group">
                    <label>
                      {{ _T('Name') }}
                      <span>*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form_data.name"
                    />
                    <div
                      class="invalid-feedback"
                      style="display:contents"
                      v-if="error.name"
                    >
                      {{ error.name[0] }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label>
                      {{ _T('Email') }}
                      <span>*</span>
                    </label>
                    <input
                      type="email"
                      class="form-control"
                      placeholder="goorder@mail.com"
                      v-model="form_data.email"
                    />
                    <div
                      class="invalid-feedback"
                      style="display:contents"
                      v-if="error.email"
                    >
                      {{ error.email[0] }}
                    </div>
                  </div>
                  <div class="form-group mb-0">
                    <label>
                      <span>{{ _T('Phone *') }}</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form_data.phone_number"
                    />
                    <div
                      class="invalid-feedback"
                      style="display:contents"
                      v-if="error.phone_number"
                    >
                      {{ error.phone_number[0] }}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="col-lg-12 text-right">
            <button
              type="button"
              class="btn btn-solid btn-lg"
              @click="submitForm"
              :disabled="under_process"
            >
              {{ _T('Submit') }}
            </button>
          </div>
        </div>
      </div>
    </section>
    <section
      class="section-b-space contact-info help-bg"
      :style="
        `background-image:url(${page_info.page.footer_background}); background-size: cover; background-position: center center; background-repeat: no-repeat; display: block;`
      "
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h2>{{ page_info.page.footer_heading }}</h2>
            <h5>{{ page_info.page.footer_desc }}</h5>
            <a
              :href="page_info.page.footer_contact_link || '#'"
              class="btn btn-solid-warning btn-lg"
              >{{ _T('Contact Us') }}</a
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from '@/utils/axios_iface'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  data: () => {
    return {
      page_loaded: false,
      under_process: false,
      error: {},
      page_info: {
        business_type: [],
        country: [],
        social_media: [
          { label: 'Instagram', code: 'instagram' },
          { label: 'Facebook', code: 'facebook' },
          { label: 'LinkedIn', code: 'linkedin' },
          { label: 'Youtube', code: 'youtube' },
        ],
        order_types: [
          { name: 'Walk-In', value: 'walk_in' },
          { name: 'Take Away', value: 'takeaway' },
          { name: 'Dine-In', value: 'dine_in' },
          { name: 'Online', value: 'online' },
          { name: 'Carhop', value: 'carhop' },
        ],
        page: {},
        menu_item_file: null,
      },
      form_data: {
        business_type: '',
        brand_name: '',
        social_media: [
          {
            for: '',
            value: '',
          },
        ],
        locations: '1',
        country: '',
        cuisine_type: '',
        more_details: '',
        order_types: [],
        other_delivery_platrforms: true,
        name: '',
        email: '',
        phone_number: '',
        brand_image: null,
        brand_logo: null,
        menu_items: null,
      },
    }
  },
  name: 'PartnerWithUs',
  computed: {
    ...mapGetters(['_T', 'api_root_url']),
    hideOrderType () {
      let that = this
      if (this.form_data.business_type) {
        var business = this.page_info.business_type.find(
          e => e.code == that.form_data.business_type.code
        )
        if (business && business.label != 'Restaurant') {
          return false
        } else {
          return true
        }
      }
      return true
    },
  },
  mounted () {
    this.getPageInfo()
  },
  methods: {
    handleUpload (e, to) {
      this.form_data[to] = null
      this.error[to] = null
      const img = e.target.files[0]
      if (to == 'brand_image' || to == 'brand_logo') {
        var reg = /(.*?)\.(jpg|bmp|jpeg|png)$/
        if (!img.name.match(reg)) {
          this.error[to] = [this._T('Upload type should be PNG ,JPG or JPEG')]
          return
        }
      } else {
        var reg1 = /(.*?)\.(xls|xlsx)$/
        if (!img.name.match(reg1)) {
          this.error[to] = [this._T('Upload type should be XLS or XLSX')]
          return
        }
      }
      if (img.size / 1000 > 1024) {
        this.error[to] = [this._T('File size must not exceed 1 MB')]
      }
      if (to == 'menu_items') {
        this.page_info.menu_item_file = img.name
      }
      this.createBase64(img, to)
    },
    createBase64 (fileObj, to) {
      const reader = new FileReader()
      reader.onload = e => {
        this.form_data[to] = e.target.result
      }
      reader.readAsDataURL(fileObj)
    },
    getPageInfo () {
      let that = this
      axios.get(`${this.api_root_url}/model/partner_with_us`).then(response => {
        that.page_info.page = response.data.data[0]
      })
      axios
        .get(
          `${this.api_root_url}/model/brand_business_type?query=&limit=10&ascending=1&page=1&byColumn=1&orderBy=name&page_id=brand_business_type_main_tbl&item_status=true`
        )
        .then(response => {
          that.page_info.business_type = []
          response.data.data.map(e => {
            that.page_info.business_type.push({
              label: e.name,
              code: e._id,
            })
          })
        })
      let countriesList = []
      axios
        .get(`${this.api_root_url}/model/countries?no_limit=1`)
        .then(response => {
          that.page_info.country = []
          response.data.data.map(e => {
            countriesList.push({
              label: e.name,
              code: e.country_code,
            })
          })
          axios
            .get(`${this.api_root_url}/model/goorder_language?no_limit=1`)
            .then(response => {
              that.page_info.country = []
              let enabledCountry = response.data.data[0].enabled_countries
              that.page_info.country = countriesList.filter(e =>
                enabledCountry.includes(e.code)
              )
            })
        })
    },
    addSocicalAccount () {
      if (this.form_data.social_media.length >= 4) {
        return
      }

      this.form_data.social_media.push({
        for: '',
        value: '',
      })
    },
    submitForm () {
      this.error = {}
      if (!this.validateForm()) {
        this.under_process = true
        let formData = this.form_data

        axios
          .post(`${this.api_root_url}/model/partner_response/add`, {
            ...formData,
            business_type: formData.business_type.code,
            country: formData.country.code,
          })
          .then(response => {
            if (response.data.status == 'ok') {
              this.$store.dispatch('showNotification', {
                text: this._T(
                  'Thank you for showing your interest!! We will contact you soon.'
                ),
                status: 'success',
              })
              this.resetForm()
            } else {
              this.error = response.data.form_errors
            }
            this.under_process = false
          })
          .catch(() => {
            this.under_process = false
            this.$store.dispatch('showNotification', {
              text: this._T('Sorry!! we are facing some technical issue'),
              status: 'error',
            })
          })
      }
    },
    resetForm () {
      this.error = {}
      this.form_data = {
        business_type: '',
        brand_name: '',
        social_media: [
          {
            for: '',
            value: '',
          },
        ],
        locations: '1',
        country: '',
        cuisine_type: '',
        more_details: '',
        order_types: [],
        other_delivery_platrforms: true,
        name: '',
        email: '',
        phone_number: '',
        brand_image: null,
        brand_logo: null,
      }
    },
    validateForm () {
      let proceedStop = false
      if (!this.form_data.business_type) {
        this.error.business_type = [this._T('Business Type is required')]
        proceedStop = true
      }
      if (!this.form_data.brand_name) {
        this.error.brand_name = [this._T('Business Name is required')]
        proceedStop = true
      }
      if (!this.form_data.country) {
        this.error.country = [this._T('Country is required')]
        proceedStop = true
      }
      if (!this.form_data.name) {
        this.error.name = [this._T('Name is required')]
        proceedStop = true
      }
      if (!this.form_data.email) {
        this.error.email = [this._T('Email is required')]
        proceedStop = true
      }
      if (!this.form_data.phone_number) {
        this.error.phone_number = [this._T('Phone is required')]
        proceedStop = true
      }
      if (!Object.keys(this.error).filter(e => this.error[e] !== null)) {
        proceedStop = true
      }
      return proceedStop
    },
  },
  components: {
    vSelect,
  },
}
</script>
<style lang="scss">
.with-us-card input.vs__search {
  min-width: 0px !important;
  /* display: none; */
  border-color: transparent !important;
}
.with-us-card {
  #vs3__combobox {
    @media (max-width: 575px) {
      max-width: 95%;
    }
  }
}
.with-us-card .vs__dropdown-toggle {
  height: 100%;
  min-height: 51px;
}
.with-us-card .v-select {
  height: 100%;
  min-height: 51px;
}
.user-account-url {
  height: 51px !important;
}
</style>
<style lang="scss" scoped>
.with-us-card .default-form1 input.vs__search {
  min-width: 0px !important;
  // display: none;
  // height: 52px;
  height: auto;
  border-color: transparent !important;
  background-color: aquamarine;
}
.with-us-card .default-form1 .vs__dropdown-toggle {
  height: 100%;
  min-height: 51px;
  @media (max-width: 575px) {
    max-width: 95%;
  }
}
.with-us-card .default-form1 .v-select {
  height: 100%;
  min-height: 51px;
}

.blog-new {
  height: 483px;
  background-color: var(--color-tertiary);
  width: 100%;
}

.help-details {
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 54vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

section,
.section-t-space {
  padding-top: calc(30px + (80 - 30) * ((100vw - 320px) / (1920 - 320)));
}

.section-b-space {
  padding-bottom: calc(30px + (80 - 30) * ((100vw - 320px) / (1920 - 320)));
}

.news-article {
  margin-top: -303px;
}

.news-article .join-us .latest-news .blog-tab .content-blog {
  padding: 0 0 calc(30px + (72 - 30) * ((100vw - 320px) / (1920 - 320)))
    calc(30px + (100 - 30) * ((100vw - 320px) / (1920 - 320)));
}

.news-article .join-us .latest-news .blog-tab {
  -webkit-box-shadow: 0px 3.48882px 8.72204px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 3.48882px 8.72204px rgba(0, 0, 0, 0.1);
  position: relative;
}

.news-article .latest-news .blog-tab {
  -webkit-box-shadow: 0px 4px 54px rgba(0, 0, 0, 0.07);
  box-shadow: 0px 4px 54px rgba(0, 0, 0, 0.07);
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.news-article .join-us .latest-news .blog-tab .content-blog h2::before {
  position: absolute;
  content: '';
  width: 65px;
  height: 3px;
  left: -15px;
  top: -29px;
  background-color: #fff;
}

.ratio_40 .bg-size:before {
  padding-top: 40%;
  content: '';
  display: block;
}

.news-article .join-us .ratio_40 .bg-size:before {
  padding-top: 18%;
}

h2 {
  font-size: calc(24px + (32 - 24) * ((100vw - 320px) / (1920 - 320)));
  letter-spacing: 0.7px;
  text-transform: uppercase;
  font-weight: 700;
}

.news-article .join-us .latest-news .blog-tab .content-blog h2 {
  margin-bottom: 12px;
  position: relative;
}

.news-article .latest-news h2 {
  font-weight: bold;
  line-height: 40px;
  color: #fff;
  text-transform: inherit;
  margin-bottom: 16px;
}

.news-article .join-us .latest-news .blog-tab .content-blog h6 {
  margin-bottom: 0;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.5px;
  color: #fff;
}

@media (min-width: 1240px) {
  .container {
    max-width: 1210px;
  }
}

.partner-row > .row > div + div {
  margin-top: 20px;
}

.partner-row > .row > div + div .with-us .with-us-card {
  height: 100%;
}

.with-us {
  height: 100%;
}

.with-us h3 {
  font-weight: bold;
  margin-bottom: 3px;
}

.with-us > h6 {
  line-height: 22px;
  letter-spacing: 0.5px;
  margin-bottom: 14px;
}
.radio_animated {
  position: relative;
  margin: 0 1rem 0 0;
  cursor: pointer;
}
.with-us .with-us-card {
  -webkit-box-shadow: 0px 3.48882px 8.72204px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 3.48882px 8.72204px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
}

.with-us .with-us-card .header-us {
  padding: 20px;
  background-color: var(--color-tertiary);
  color: #fff;
}

.with-us .with-us-card .header-us h4 {
  margin-bottom: 0;
  font-weight: 600;
}

.with-us .with-us-card .header-us h4 span {
  float: right;
  font-weight: bold;
  font-size: calc(30px + (48 - 30) * ((100vw - 320px) / (1920 - 320)));
  line-height: 22px;
  letter-spacing: 0.7px;
  color: #fff;
  opacity: 0.15;
}

.with-us .with-us-card form {
  padding: 30px;
}

.with-us .with-us-card form .form-group {
  margin-bottom: 16px;
}

.with-us .with-us-card form .form-group label {
  margin-bottom: 3px;
}

.with-us .with-us-card form .form-group label span {
  color: var(--color-tertiary);
}

.with-us .with-us-card form .form-group.social-account label {
  display: block;
}

.social-account .row {
  margin-bottom: 5px;
}

.with-us .with-us-card form .form-group.social-account label .add-plus {
  float: right;
  width: 16px;
  height: 16px;
  background-color: #fdb32b;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 100%;
  margin-top: 3px;
}

.with-us .with-us-card form .form-group.social-account label .add-plus img {
  width: 73%;
}

.with-us .with-us-card form .form-group.social-account select {
  color: #2f80ed;
}

.with-us .with-us-card form .form-group select {
  border-radius: 4px;
  background: url(/images/svg/down.svg) no-repeat 96% 54%;
  -webkit-appearance: none;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.5px;
  color: #a19d97;
  // height: 52px;
  height: auto;
  border-color: #edeff4;
  padding-left: 22px;
  border-radius: 5px;
}

.vs__dropdown-toggle {
  height: 51px;
}
.with-us .with-us-card form .form-group input,
.vs__selected {
  // height: 52px;
  height: auto;
}
.with-us .with-us-card form .form-group input:not(.vs__search),
.with-us .with-us-card form .form-group textarea,
.vs__selected {
  color: #a19d97;
  font-weight: normal;
  padding: 9px 12px 9px 22px;
  border-radius: 5px;
}

.with-us .with-us-card .upload-images {
  padding: calc(30px + (58 - 30) * ((100vw - 320px) / (1920 - 320)))
    calc(20px + (60 - 20) * ((100vw - 320px) / (1920 - 320)));
}

.with-us .with-us-card .upload-images .media {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 22px;
}

.with-us .with-us-card .upload-images .media .round-bulb {
  width: 36px;
  height: 36px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 100%;
  background-color: rgba(253, 179, 43, 0.1);
}

.with-us .with-us-card .upload-images .media .media-body {
  margin-left: 10px;
}

.with-us .with-us-card .upload-images .media .media-body p {
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: #a19d97;
  margin-bottom: 0;
}

.with-us .with-us-card .upload-images .upload-box {
  width: 362px;
  @media (max-width: 575px) {
    width: auto !important;
  }
  height: 230px;
  border: 1px dashed #edeff4;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-align: center;
  border-radius: 4px;
}

.with-us .with-us-card .upload-images .upload-box.upload-menu {
  height: 100px !important;
}

.with-us .with-us-card .upload-images .upload-box + .upload-box {
  margin-top: 30px;
}

.with-us .with-us-card .upload-images .upload-box .plus-icon {
  width: 32px;
  height: 32px;
  border-radius: 100%;
  background-color: #fdb32b;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 0 auto;
}

.with-us .with-us-card .upload-images .upload-box h6 {
  line-height: 160%;
  letter-spacing: 0.5px;
  color: #fdb32b;
  margin: 8px 0 0;
}

.with-us .with-us-card .order-choice {
  padding: 30px;
}

.with-us .with-us-card .order-choice .choice-option + .choice-option {
  margin-top: calc(20px + (35 - 20) * ((100vw - 320px) / (1920 - 320)));
}

.with-us .with-us-card .order-choice .choice-option h6 {
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.5px;
  color: #3d3f43;
  margin-bottom: 15px;
}

.with-us .with-us-card .order-choice .choice-option h6 span {
  float: right;
  color: var(--color-tertiary);
  @media (max-width: 575px) {
    float: none;
    display: block;
    margin-top: 5px;
  }
}

.with-us .with-us-card .order-choice .choice-option .desired-time {
  margin-top: 0;
}

.with-us
  .with-us-card
  .order-choice
  .choice-option
  .desired-time
  .box-checkbox
  .timing-checkbox {
  margin: 0;
  padding: 0;
  border-top: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: inherit;
  @media (max-width: 575px) {
    display: grid !important;
  }
  height: auto;
}

.with-us
  .with-us-card
  .order-choice
  .choice-option
  .desired-time
  .box-checkbox
  .timing-checkbox
  li {
  min-width: 133px;
}

.with-us
  .with-us-card
  .order-choice
  .choice-option
  .desired-time
  .box-checkbox
  .timing-checkbox
  li
  label {
  margin-bottom: 0;
  width: 100%;
  position: relative;
  cursor: pointer;
}

.with-us
  .with-us-card
  .order-choice
  .choice-option
  .desired-time
  .box-checkbox
  .timing-checkbox
  li
  label
  span {
  padding: calc(8px + (20 - 8) * ((100vw - 320px) / (1920 - 320)));
  border: 2px solid #edeff4;
  display: block;
  background-color: #fff;
  border-radius: 4px;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.5px;
  text-align: left;
}

.with-us
  .with-us-card
  .order-choice
  .choice-option
  .desired-time
  .box-checkbox
  .timing-checkbox
  li {
  margin: 10px;
}

.with-us
  .with-us-card
  .order-choice
  .choice-option
  .desired-time
  .box-checkbox
  .timing-checkbox
  li
  + li
  + li {
  margin-top: 0;
}

.with-us
  .with-us-card
  .order-choice
  .choice-option
  .desired-time
  .box-checkbox
  .timing-checkbox.multichoice
  li
  label
  .checkbox_animated {
  float: right;
  margin-right: 7px;
  margin-top: 2px;
  opacity: 0;
}
.checkbox_animated:after {
  content: '';
  position: absolute;
  top: -0.125rem;
  left: -2px;
  width: 1.3rem;
  height: 1.3rem;
  background: var(--color-primary);
  cursor: pointer;
  border-radius: 0.125rem;
}
.with-us
  .with-us-card
  .order-choice
  .choice-option
  .desired-time
  .box-checkbox
  .timing-checkbox.multichoice
  li
  label
  .checkbox_animated:after {
  border-radius: 4px;
  background-color: #fff;
  border: none;
}

.with-us
  .with-us-card
  .order-choice
  .choice-option
  .desired-time
  .box-checkbox
  .timing-checkbox.multichoice
  li
  label
  .checkbox_animated:before {
  -webkit-transition: -webkit-transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
  transition: -webkit-transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
  transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
  transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75),
    -webkit-transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
  -webkit-transform: rotate(-45deg) scale(0, 0);
  transform: rotate(-45deg) scale(0, 0);
  left: 5px;
  top: 4px;
  z-index: 1;
  width: 0.75rem;
  height: 0.375rem;
  border: 2px solid #fff;
  border-top-style: none;
  border-right-style: none;
  background: transparent;
  border-radius: 0;
}

.with-us
  .with-us-card
  .order-choice
  .choice-option
  .desired-time
  .box-checkbox
  .timing-checkbox.multichoice
  li
  label
  .checkbox_animated:checked {
  opacity: 1;
}

.with-us
  .with-us-card
  .order-choice
  .choice-option
  .desired-time
  .box-checkbox
  .timing-checkbox.multichoice
  li
  label
  .checkbox_animated:checked:after {
  background-color: #fdb32b;
}

.with-us
  .with-us-card
  .order-choice
  .choice-option
  .desired-time
  .box-checkbox
  .timing-checkbox.multichoice
  li
  label
  .checkbox_animated:checked:before {
  -webkit-transform: rotate(-45deg) scale(1, 1);
  transform: rotate(-45deg) scale(1, 1);
}

.with-us
  .with-us-card
  .order-choice
  .choice-option
  .desired-time
  .box-checkbox
  .timing-checkbox.multichoice
  li
  label
  .checkbox_animated:checked
  ~ span {
  border: 2px solid #fdb32b;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  color: #fdb32b;
}

.with-us
  .with-us-card
  .order-choice
  .choice-option
  .desired-time
  .box-checkbox
  ul
  li
  label
  .radio_animated:checked:after {
  background-color: #fdb32b;
}

.desired-time {
  margin-top: calc(20px + (50 - 20) * ((100vw - 320px) / (1920 - 320)));
}
.desired-time .box-checkbox ul {
  margin: 0;
}
.desired-time .box-checkbox ul li label {
  margin-bottom: 0;
  width: 100%;
  position: relative;
  cursor: pointer;
}
.desired-time .box-checkbox ul li label .radio_animated {
  float: right;
  margin-right: 6px;
  margin-top: 5px;
  opacity: 0;
}
.desired-time .box-checkbox ul li label .radio_animated:after {
  border-radius: 2px;
  background-color: #fff;
  border: none;
}
.desired-time .box-checkbox ul li label .radio_animated:before {
  -webkit-transition: -webkit-transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
  transition: -webkit-transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
  transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
  transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75),
    -webkit-transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
  -webkit-transform: rotate(-45deg) scale(0, 0);
  transform: rotate(-45deg) scale(0, 0);
  left: 3px;
  top: 1px;
  z-index: 1;
  width: 0.75rem;
  height: 0.375rem;
  border: 2px solid #fff;
  border-top-style: none;
  border-right-style: none;
  background: transparent;
  border-radius: 0;
}
.desired-time .box-checkbox ul li label .radio_animated:checked {
  opacity: 1;
}
.desired-time .box-checkbox ul li label .radio_animated:checked:after {
  background-color: var(--primary-color);
}
.desired-time .box-checkbox ul li label .radio_animated:checked:before {
  -webkit-transform: rotate(-45deg) scale(1, 1);
  transform: rotate(-45deg) scale(1, 1);
}
.desired-time .box-checkbox ul li label .radio_animated:checked ~ span {
  border: 2px solid var(--primary-color);
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  color: var(--primary-color);
}
.desired-time .box-checkbox ul li label span {
  padding: calc(8px + (15 - 8) * ((100vw - 320px) / (1920 - 320)));
  border: 2px solid #edeff4;
  display: block;
  border-radius: 4px;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  font-weight: 600;
  font-size: calc(14px + (16 - 14) * ((100vw - 320px) / (1920 - 320)));
  line-height: 19px;
  text-align: center;
  letter-spacing: 0.02em;
}
.desired-time .box-checkbox ul li.col-sm-6:nth-child(odd) {
  padding: 0;
}
.desired-time .box-checkbox ul li.col-sm-6:nth-child(even) {
  padding-right: 0;
}
.desired-time .box-checkbox .timing-checkbox {
  padding-top: calc(16px + (30 - 16) * ((100vw - 320px) / (1920 - 320)));
  margin-top: calc(16px + (30 - 16) * ((100vw - 320px) / (1920 - 320)));
  border-top: 1px solid #edeff4;
  height: 346px;
  overflow: auto;
}
.desired-time .box-checkbox .timing-checkbox::-webkit-scrollbar {
  width: 0 !important;
}
.desired-time .box-checkbox .timing-checkbox li label span {
  border: 2px solid #f6f5f5;
  background: #f6f5f5;
}
.desired-time .box-checkbox .timing-checkbox li label .radio_animated:after {
  background: #f6f5f5;
}
.desired-time
  .box-checkbox
  .timing-checkbox
  li
  label
  .radio_animated:checked
  ~ span {
  background-color: #fff;
}
.desired-time
  .box-checkbox
  .timing-checkbox
  li
  label
  .radio_animated:disabled
  ~ span {
  color: rgba(61, 63, 67, 0.3);
}
.desired-time .box-checkbox .timing-checkbox li + li + li {
  margin-top: 15px;
}
.desired-time h4 {
  margin-bottom: calc(
    8px + (10 - 8) * ((100vw - 320px) / (1920 - 320))
  ) !important;
}
.with-us
  .with-us-card
  .order-choice
  .choice-option
  .desired-time
  .box-checkbox
  ul
  li
  label
  .radio_animated:checked
  ~ span {
  color: #fdb32b;
  border-color: #fdb32b;
}

.contact-info {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100%;
  width: 100%;
  text-align: center;
  padding: calc(60px + (136 - 60) * ((100vw - 320px) / (1920 - 320))) 0;
  position: relative;
  z-index: 1;
}

.contact-info::after {
  background-color: var(--color-tertiary);
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.8;
  z-index: -1;
}

.contact-info h3 {
  font-size: calc(20px + (30 - 20) * ((100vw - 320px) / (1920 - 320)));
  line-height: calc(31px + (36 - 31) * ((100vw - 320px) / (1920 - 320)));
  letter-spacing: -0.8px;
  color: #fff;
  text-transform: inherit;
  font-weight: normal;
  margin: -6px 0 calc(30px + (38 - 30) * ((100vw - 320px) / (1920 - 320)));
}

.contact-info .btn:hover,
.contact-info .btn:focus,
.contact-info .btn:active {
  color: #000;
}

@media (max-width: 575px) {
  .partner-with-us {
    display: -moz-inline-grid;
    display: inline-grid;
  }
}
.form-control {
  font-size: 0.875rem;
  ::placeholder,
  :-ms-input-placeholder,
  ::-ms-input-placeholder {
    color: rgba($black, 0.5);
    opacity: 0.5;
    font-weight: normal;
  }
}
</style>
